import { PrgHandler } from '../utilities/prg';

class NavigationPanel {
  constructor() {
    this.bodyEl = document.querySelector('body');
    this.showButtonEl = document.querySelectorAll('[data-aside-toggle]');
    this.backButtonEl = document.querySelectorAll('[data-aside-back]')
    this.closeButtonEl = document.querySelector('[data-aside-close]');
    this.asideEl = document.querySelector('[data-aside]');
    // Control whether the container's children can be focused
    // Set initial state to inert since the panel is offscreen
    this.asideEl.inert = true;
    this.asideInnerEl = document.querySelector('[data-aside-inner]');
    // The panel to open
    this.panel = null;
    this.panelStack = [];

    // Handle PRG compliant links
    this.prgHandler = new PrgHandler('[data-prg-data]:not([data-aside-toggle])');

    this.showPanel = this.showPanel.bind(this);
    this.hidePanel = this.hidePanel.bind(this);
    this.hideAll = this.hideAll.bind(this);
    this.addBackdrop = this.addBackdrop.bind(this);
    this.removeBackdrop = this.removeBackdrop.bind(this);
    this.blockClicks = this.blockClicks.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);
    this.update = this.update.bind(this);

    this.startX = 0;
    this.currentX = 0;
    this.touchingSideNav = false;
    this.offsetTop = 0;

    this.menuLevel = 0;

    this.transitionEndProperty = null;
    this.transitionEndTime = 0;

    this.hasBackdrop = false;

    this.supportsPassive = undefined;
    this.addEventListeners();
  }

  addEventListeners() {
    this.showButtonEl.forEach((el) => el.addEventListener('click', this.showPanel));
    this.backButtonEl.forEach((el) => el.addEventListener('click', this.hidePanel));
    this.closeButtonEl.addEventListener('click', this.hideAll);
    document.addEventListener('click', (evt) => {
      const isWithinBoundaries = evt.composedPath().includes(this.asideEl);
      if (isWithinBoundaries && evt.target === this.asideEl) {
        this.hideAll(); // Close on click outside panel
      }
    });

    document.addEventListener('keydown', (evt) => {
      const key = evt.key;
      if (key === 'Escape') {
        this.hideAll(); // Esc kills everything
      }
    });
  }

  update() {
    if (!this.touchingSideNav) {
      return;
    }

    requestAnimationFrame(this.update);

    const translateX = Math.max(0, this.currentX - this.startX);
    this.asideInnerEl.style.transform = `translateX(${translateX}px)`;
  }

  blockClicks(evt) {
    if (typeof evt !== 'undefined' && evt.currentTarget.hasAttribute('data-aside-toggle')) {
      evt.preventDefault();
    }
  }

  blockPropagation(evt) {
    evt.stopPropagation();
  }

  onTransitionEnd(evt) {
    if (evt.propertyName !== this.transitionEndProperty && evt.elapsedTime !== this.transitionEndTime) {
      return;
    }
    this.transitionEndProperty = null;

    this.transitionEndTime = 0;
    this.asideEl.classList.remove('c-aside--is-animatable');
    this.panel.classList.remove('c-aside__panel--is-animatable');

    this.asideEl.removeEventListener('transitionend', this.onTransitionEnd);
    this.panel.removeEventListener('transitionend', this.onTransitionEnd);
  }

  addBackdrop() {
    this.bodyEl.classList.add('u-no-scroll');
    this.asideEl.classList.add('c-aside--is-animatable');
    this.asideEl.classList.add('c-aside--is-visible');
    this.asideEl.inert = false;

    this.offsetTop = window.scrollY;
    this.bodyEl.style.top = -this.offsetTop + 'px';

    this.hasBackdrop = true;
  }

  removeBackdrop() {
    this.bodyEl.classList.remove('u-no-scroll');
    this.asideEl.classList.add('c-aside--is-animatable');
    this.asideEl.classList.remove('c-aside--is-visible');
    this.asideEl.inert = true;

    window.scrollTo(0, this.offsetTop);
    this.bodyEl.removeAttribute('style');

    this.hasBackdrop = false;
  }

  showPanel(evt) {
    if (!this.hasBackdrop) {
      this.addBackdrop();
    }

    this.blockClicks(evt);

    this.menuLevel = parseInt(evt.currentTarget.getAttribute('data-aside-level'), 10);

    if (this.menuLevel === 1 && this.panelStack.length >= 3) {
      const panel = this.panelStack.at(-1);
      panel.classList.add('c-aside__panel--is-animatable');
      panel.classList.remove('c-aside__panel--is-visible');
      this.panelStack.pop();
    }

    const panelIDs = evt.currentTarget.getAttribute('data-aside-toggle').split(',');
    panelIDs.forEach((id) => {
      this.panel = document.querySelector(`[data-aside-panel="${parseInt(id, 10)}"]`);
      this.panel.classList.add('c-aside__panel--is-animatable');
      this.panel.classList.add('c-aside__panel--is-visible');
      this.panel.focus();

      this.panel.addEventListener('transitionend', this.onTransitionEnd);
      this.panelStack.push(this.panel);
    });

    this.transitionEndProperty = 'transform';
    this.transitionEndTime = 0.33;
  }

  hidePanel(evt) {
    this.blockClicks(evt);

    this.menuLevel = parseInt(evt.currentTarget.getAttribute('data-aside-level'), 10);
    const panelsToHide = this.panelStack.splice(this.menuLevel); // menu level corresponds to stack index

    panelsToHide.forEach(panel => {
      this.panel = panel;
      this.panel.classList.add('c-aside__panel--is-animatable');
      this.panel.classList.remove('c-aside__panel--is-visible');

      this.panel.addEventListener('transitionend', this.onTransitionEnd);
    });

    this.transitionEndProperty = 'transform';
    this.transitionEndTime = 0.13;

    if (this.panelStack.length === 0) {
      this.removeBackdrop();
    }
  }

  hideAll(evt) {
    this.removeBackdrop(evt);

    this.panelStack.forEach((el) => {
      el.classList.add('c-aside__panel--is-animatable');
      el.classList.remove('c-aside__panel--is-visible');

      this.transitionEndProperty = 'transform';
      this.transitionEndTime = 0.13;

      el.addEventListener('transitionend', this.onTransitionEnd);
    });

    this.panelStack = []; // reset stack
  }
}

const mainNavigation = document.querySelector('.c-site-header__navigation');

if (mainNavigation) {
  new NavigationPanel();
}
